<template>
  <!-- 客户分组 -->
  <div class="memGroup">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="getTableData('refresh')"
      :crumbsList="['客户管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd('')"
          >新增客户分组</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </crumbs-bar>

    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          style="width: 100px"
          v-model="searchForm.status"
          placeholder="状态"
          clearable
        >
          <el-option label="全部" value="9"></el-option>
          <el-option label="启用" value="2"></el-option>
          <el-option label="禁用" value="1"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-left: 5px"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button
          style="margin-left: 5px"
          type="primary"
          icon="el-icon-search"
          @click="getTableData()"
          >搜索</el-button
        >
      </template>
    </search-bar>

    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      @selection-change="selectionChange"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="GroupId"
        show-overflow-tooltip
        label="编号"
      >
      </el-table-column>
      <el-table-column
        prop="GroupName"
        align="center"
        show-overflow-tooltip
        label="分组名称"
      >
      </el-table-column>
      <el-table-column
        prop="Lastmodifytime"
        align="center"
        show-overflow-tooltip
        label="修改时间"
      >
      </el-table-column>
      <el-table-column
        prop="Status"
        align="center"
        show-overflow-tooltip
        label="状态"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.Status == 2" type="success">启用中</el-tag>
          <el-tag v-else-if="scope.row.Status == 1" type="warning"
            >禁用中</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200px">
        <template slot-scope="scope">
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleBind(scope.row)"
            >管理</el-button
          >
          <!-- <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleDel(scope.row)"
            >删除</el-button
          > -->
          <el-button
            v-if="scope.row.Status == 1"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 2)"
            >启用</el-button
          >
          <el-button
            v-if="scope.row.Status == 2"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, 1)"
            >禁用</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 添加管理员 -->
    <el-drawer
      title=""
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">新增客户分组</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form :model="addForm">
            <el-form
              :model="addForm"
              label-position="rigth"
              label-width="80px"
              ref="addForm"
              :rules="addFormRule"
            >
              <el-form-item label="分组名称" prop="name">
                <el-input v-model="addForm.name" clearable></el-input>
              </el-form-item>
            </el-form>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>使用场景：促销规则、新增优惠券中添加客户白名单/黑名单</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "memGroup",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**新增分组drawer */
      addDrawer: false,
      /**搜索表单 */
      searchForm: {
        name: "",
        status: "9", //(1 未启用 2 已启用 9 全部)
      },
      /**新增分组表单 */
      addForm: {
        id: "",
        name: "",
      },
      /**新增表格数据 */
      addFormRule: {
        name: [mustFill],
      },
      submitType: "add", //提交类型，编辑还是新增

      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格数据 */
    getTableData(fun = "") {
      //函数太多 type: refresh search 不传参数默认加载
      if (fun == "refresh") {
        this.searchForm.status = "9";
        this.searchForm.name = "";
        this.currPage = 1;
      } else if (fun == "search") {
        this.currPage = 1;
      }

      let data = {
        entId: window.localStorage.getItem("entId"),
        status: this.searchForm.status, //Y启用 N禁用  传空获取全部
        searchVal: this.searchForm.name, //关键字
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };

      this.$request({
        url: "Member/GetMemberGroup",
        method: "post",
        data,
      })
        .then((res) => {
          this.tableData = res.list;
          this.allPage = res.toTal;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // getTableData(fun, num) {
    //   //函数太多 type: refresh search 不传参数默认加载
    //   if (fun == "refresh") {
    //     this.searchForm.status = "9";
    //     this.searchForm.name = "";
    //     this.currPage = 1;
    //   } else if (fun == "search") {
    //     this.currPage = 1;
    //   }
    //   this.currPage = num == 1 ? 1 : this.currPage;
    //   let data = {
    //     type: "GetPromGoodsGroup",
    //     status: this.searchForm.status,
    //     strWhere: this.searchForm.name,
    //     PageIndex: this.currPage,
    //     PageSize: this.pageSize,
    //   };
    //   let proc = "Proc_PromGoodsGroup"; //存储过程名
    //   let type = "ReturnList";
    //   this.$requestSys({
    //     url:
    //       "prom/ashx/ReturnJson.ashx?type=" +
    //       type +
    //       "&json=" +
    //       encodeURIComponent(JSON.stringify(data)) +
    //       "&proc=" +
    //       proc,
    //     method: "post",
    //   })
    //     .then((res) => {
    //       this.tableData = [];
    //       this.allPage = res.recordCount;
    //       if (res.flag == 0) {
    //         this.tableData = res.data.map((item) => ({
    //           id: item.GroupId,
    //           entId: item.entname,
    //           entName: item.entname,
    //           name: item.GroupName,
    //           type: item.Genre,
    //           sort: item.sort || 1,
    //           num: item.GoodsCount,
    //           time: item.addTime,
    //           status: item.Status,
    //         }));
    //       }
    //     })
    //     .catch((err) => {
    //       window.console.log(err);
    //     });
    // },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
    },

    /**新增 */
    handleAdd() {
      this.submitType = "add";
      this.clearForm();
      this.addDrawer = true;
    },

    /**编辑 */
    handleEdit(row) {
      this.submitType = "edit";
      //取的数据是selectedList中的最后一条
      let { GroupId, GroupName } = row;
      this.addForm.id = GroupId;
      this.addForm.name = GroupName;
      this.addDrawer = true;
    },

    // 管理绑定客户
    handleBind(row) {
      let prams = null;
      prams = encodeURIComponent(JSON.stringify({ id: row.GroupId }));
      this.$router.push({
        path: "bindUserGroup",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },

    /**修改状态 */
    changeStatus(row, status) {
      //未选中判断
      this.$request({
        url: "Member/UpdateMemberGroupStatus",
        method: "post",
        data: {
          entId: window.localStorage.getItem("entId"),
          groupId: row.GroupId,
          status,
        },
      })
        .then((res) => {
          let type = res.success ? "success" : "error";
          //提示成功，关闭dialog
          this.$message({
            message: type,
            type,
          });

          if (res.success) {
            this.getTableData("refresh");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.addForm.id = "";
      this.addForm.name = "";
      this.addDrawer = false;
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      this.selectedList = section;
    },
    /**删除 */
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        // this.$confirm("确定删除吗?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "error",
        // })
        //   .then(() => {
        row = this.selectedList[0];
        // this.deteDel(row);
        //     })
        //     .catch(() => {});
        // } else {
        //   this.$message({
        //     message: "只能删除一条数据",
        //     type: "warning",
        //   });
      }
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //未选中判断
          this.$request({
            url: "Member/UpdateMemberGroupStatus",
            method: "post",
            data: {
              entId: window.localStorage.getItem("entId"),
              groupId: row.GroupId,
              status: 0,
            },
          })
            .then((res) => {
              let type = res.success ? "success" : "error";
              //提示成功，关闭dialog
              this.$message({
                message: type,
                type,
              });

              if (res.success) {
                this.getTableData("refresh");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },

    /**提交表单 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          //获取区域的编码
          let data = null;
          let url = "Member/SaveMemberGroup";
          if (this.submitType === "add") {
            data = {
              entId: window.localStorage.getItem("entId"),
              groupName: this.addForm.name,
            };
          } else {
            data = {
              groupId: this.addForm.id, //序号 ，0 表示新增  原序号表示编辑
              entId: window.localStorage.getItem("entId"),
              groupName: this.addForm.name,
            };
          }

          this.$request({
            url,
            method: "post",
            data,
          }).then((res) => {
            let type = res.success ? "success" : "error";

            this.$message({
              message: type,
              type: type,
            });

            if (res.success) {
              //关闭drawer，清空表单，刷新数据
              this.clearForm();
              this.getTableData("refresh");
            }
          });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.memGroup {
  width: 100%;
  height: 100%;
}
</style>
